import React,{Component} from 'react';
class Svg extends Component{
    constructor(props) {
        super(props);
        
    }
    render() {
        const { className, width, height, xlinkHref, title, ...others } = this.props;
        return (
            <svg
                className={`icon ${className}`}
                style={{width: `${width}px`, height: `${height}px`}}
                aria-hidden="true"
                {...others}
            >
                <use xlinkHref={xlinkHref}></use>
                <title>{title}</title>
            </svg>
        );
    }
}
export default Svg;